import { Grid } from "@mui/material";
import { PublicationApprovalStatus } from "generated/CoreApi_v1";
import { FavoriteButton, FollowButton, ShareButton } from "views/knowledge/components/card/behaviors/common/Interaction";
import { PlaybackButton, SeeListButton } from "views/knowledge/components/card/behaviors/list/defaults";
import { FeedOptions } from "views/knowledge/components/card/behaviors/list/MenuOptions";
import { useCardContext } from "views/knowledge/components/card/CardBuilder";
import { ModeratorMessageButton } from "../../actions/ModeratorMessageDialog";
import { DefaultModerationFooter } from "../common/DefaultModerationFooter";

///
export const FeedStartupFooter = () => {
    const { pub: { listDefinition, approvalStatus, blocked } } = useCardContext();

    if (approvalStatus != PublicationApprovalStatus.Approved)
        return <DefaultModerationFooter />;

    return (
        <Grid container justifyContent="space-between" alignItems="center">
            <Grid>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                    <Grid>
                        {
                            listDefinition!.openInPlayback
                                ?
                                <PlaybackButton />
                                :
                                <SeeListButton />
                        }
                    </Grid>
                    {
                        listDefinition!.isPublic &&
                        <Grid>
                            <FollowButton />
                        </Grid>
                    }
                </Grid>
            </Grid>
            {blocked?.blockedOn != null &&
                <Grid>
                    <ModeratorMessageButton optionMode="blocked" />
                </Grid>
            }
            <Grid>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid>
                        <FavoriteButton />
                    </Grid>
                    <Grid>
                        <ShareButton />
                    </Grid>
                    <Grid>
                        <FeedOptions />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
